'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _startCase2 = require('lodash/startCase');

var _startCase3 = _interopRequireDefault(_startCase2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class, _desc, _value, _class2, _descriptor, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _common = require('../common');

var _pageContacts = require('../page-contacts');

var _FormattingUtils = require('../../utils/FormattingUtils');

var _FormattingUtils2 = _interopRequireDefault(_FormattingUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var getNameOrDefault = _FormattingUtils2.default.getNameOrDefault;
var OrganizationDetailPage = (_dec = (0, _mobxReact.inject)('Clients'), _dec2 = (0, _common.loaderDecorator)({
  actions: function actions(props) {
    var Clients = props.Clients,
        id = props.params.id;

    return {
      organization: { method: Clients.organizations.retrieve, params: id },
      people: { method: Clients.relationships.list, params: { params: { first_party: id } } }
    };
  },
  className: 'page-loader',
  logo: true,
  Wrapper: function Wrapper(data) {
    return (// eslint-disable-line react/display-name
      _react2.default.createElement(
        _common.Page,
        { name: 'contact', type: 'detail' },
        _react2.default.createElement(_reactHelmet2.default, { title: (0, _startCase3.default)((0, _get3.default)(data, 'organization.human_readable_type', '')) + ' - ' + getNameOrDefault(data.organization) }),
        _react2.default.createElement(
          _common.Page.Content,
          null,
          data.children
        )
      )
    );
  } }), _dec(_class = _dec2(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(OrganizationDetailPage, _Component);

  function OrganizationDetailPage(props) {
    _classCallCheck(this, OrganizationDetailPage);

    var _this = _possibleConstructorReturn(this, (OrganizationDetailPage.__proto__ || Object.getPrototypeOf(OrganizationDetailPage)).call(this, props));

    _initDefineProp(_this, 'organization', _descriptor, _this);

    _this.organization = props.organization;
    return _this;
  }

  _createClass(OrganizationDetailPage, [{
    key: 'setOrganizationOnSave',
    value: function setOrganizationOnSave(organization) {
      this.organization = organization;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_pageContacts.ContactDetail, {
        contact: this.organization,
        people: (0, _get3.default)(this.props.people, 'results', []),
        setOrganizationOnSave: this.setOrganizationOnSave
      });
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return OrganizationDetailPage;
}(_react.Component), _class3.propTypes = {
  organization: _propTypes2.default.object.isRequired,
  people: _propTypes2.default.object
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'organization', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
})), _class2)) || _class) || _class) || _class) || _class);
var _default = OrganizationDetailPage;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getNameOrDefault, 'getNameOrDefault', '/app/src/components/pages/OrganizationDetailPage.js');
  reactHotLoader.register(OrganizationDetailPage, 'OrganizationDetailPage', '/app/src/components/pages/OrganizationDetailPage.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/pages/OrganizationDetailPage.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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